export const isPlace = (placeType) =>
  placeType === 'trail' || placeType === 'place' || placeType === 'google';

export const isAmenity = (placeType) => !isPlace(placeType);
